import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/Button.jsx';
import Card from '../components/Card.jsx';
import NotFound from './NotFound.jsx';
import {
  getCategoryPageContent,
  getInvitationCategory,
  getTemplatesByCategory,
  getVisibleInvitationCategories,
} from '../lib/invitationCatalog.js';
import '../styles/Invitations.css';
import '../styles/InvitationCategory.css';

export default function InvitationCategory({ categoryKey }) {
  const category = getInvitationCategory(categoryKey);
  const page = getCategoryPageContent(categoryKey);
  const templates = getTemplatesByCategory(categoryKey);

  if (!category || !page) {
    return <NotFound />;
  }

  const relatedCategories = getVisibleInvitationCategories().filter(
    (item) => item.value !== categoryKey
  );

  return (
    <div className="invitation-category-page">
      <section className="invitation-category-hero">
        <p className="invitation-category-eyebrow">{page.eyebrow}</p>
        <h1>{page.heading}</h1>
        <p className="invitation-category-description">{page.description}</p>

        <div className="invitation-category-actions">
          <Link to="/book">
            <Button variant="primary" size="large">
              {page.ctaLabel}
            </Button>
          </Link>
          <Link to="/invitations" className="invitation-category-secondary-link">
            View all digital invitation templates
          </Link>
        </div>

        <div className="invitation-category-metrics">
          {page.metrics.map((item) => (
            <article key={item.label} className="invitation-category-metric-card">
              <span>{item.label}</span>
              <strong>{item.value}</strong>
            </article>
          ))}
        </div>
      </section>

      <section className="invitation-category-benefits">
        <div className="invitation-section-heading">
          <h2>Why this invitation category works</h2>
          <p>{page.lead}</p>
        </div>
        <div className="invitation-category-highlights">
          {page.highlights.map((highlight) => (
            <article key={highlight} className="invitation-category-highlight-card">
              <p>{highlight}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="invitation-category-templates-section">
        <div className="invitation-section-heading">
          <h2>{category.label} invitation templates</h2>
          <p>{page.templateLead}</p>
        </div>

        <div className="templates-grid invitation-category-grid">
          {templates.map((template) => (
            <div key={template.id} className="template-card-wrapper">
              <Link to={`/${template.category}/templates/${template.slug}`} className="preview-overlay">
                <span className="preview-text">Click to Preview</span>
              </Link>
              <Card
                title={template.title}
                description={template.description}
                image={template.image}
                className="template-card"
                category={template.category}
                categoryLabel={category.label}
              />
            </div>
          ))}
        </div>
      </section>

      <section className="invitation-category-related">
        <div className="invitation-section-heading">
          <h2>Explore more digital invitation categories</h2>
          <p>
            Compare other event-specific landing pages if you are still choosing the right invitation style.
          </p>
        </div>

        <div className="invitation-category-links">
          {relatedCategories.map((item) => (
            <Link key={item.value} to={item.path} className="invitation-category-link-card">
              <span className="invitation-category-link-label">{item.label}</span>
              <h3>{item.headline}</h3>
              <p>{item.blurb}</p>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}